import { FC } from 'react';

import { AppRoutes } from 'constants/routes-paths.constants';
import { City } from 'interfaces/cities.interfaces';
import { ColumnDefaultControls } from 'shared-components/table/ColumnDefaultControls';
import { TableData } from 'shared-components/table/TableData';
import { TableRow } from 'shared-components/table/TableRow';
import { getCommonRoutes } from 'utils/routes.utils';

interface Props {
  handleDelete: VoidFunction;
  data: City;
}

export const CitiesTableRow: FC<Props> = ({ handleDelete, data: { id, name, country } }) => {
  const { editRoute, viewRoute } = getCommonRoutes(AppRoutes.cities, id);

  return (
    <TableRow>
      <TableData className='w-fit'>
        <ColumnDefaultControls
          handleDelete={handleDelete}
          editRoute={editRoute}
          viewRoute={viewRoute}
          editPermission='cities.update'
          deletePermission='cities.delete'
          viewPermission='cities.view'
        />
      </TableData>
      <TableData>{id}</TableData>
      <TableData>{name}</TableData>
      <TableData className='last:text-left'>{country.name}</TableData>
    </TableRow>
  );
};
